module.exports = __webpack_public_path__ + "static/img/scene_2.b1360b86.png";